/**
 * Mirrors Angular `ReportPaymentlogsDetailComponent.backtolist()`:
 * - `#payment` → application Payment tab
 * - list navigators can pass `location.state.returnTo` (e.g. Balance Report)
 * - otherwise fall back to browser history
 */

export const BALANCE_REPORT_PAYMENT_LOG_NAV_STATE = {
  from: 'balances_report',
  returnTo: '/reports/balances_report',
  returnLabel: 'Back',
} as const

export type PaymentLogDetailNavState = {
  from?: string
  returnTo?: string
  returnLabel?: string
}

export function isBalanceReportPaymentLogNav(
  state: unknown,
): state is PaymentLogDetailNavState {
  if (!state || typeof state !== 'object') return false
  return (state as PaymentLogDetailNavState).from === 'balances_report'
}

export function paymentLogBackToListTarget(
  hash: string | undefined,
  applicantId: string | number | null | undefined,
): string | null {
  const fragment = (hash ?? '').replace(/^#/, '')
  if (fragment !== 'payment' || applicantId == null || applicantId === '') return null
  return `/application/${applicantId}#payment`
}

/** Prefer explicit list return path from navigation state, then `#payment` target. */
export function resolvePaymentLogBackTarget(options: {
  hash?: string
  applicantId?: string | number | null
  state?: unknown
}): string | null {
  const navState =
    options.state && typeof options.state === 'object'
      ? (options.state as PaymentLogDetailNavState)
      : null
  if (navState?.returnTo && typeof navState.returnTo === 'string') {
    return navState.returnTo
  }
  return paymentLogBackToListTarget(options.hash, options.applicantId)
}
